export default __webpack_public_path__ + "static/11_9-9bb10659158079bbb2a66fafdf79855a.png";